import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import { General, Coverage } from '../components/Settings';

const SettingsRouter: FC = () => (
    <Routes>
        <Route path="/general" element={<General />} />
        <Route path="/coverage" element={<Coverage />} />
    </Routes>
);

export { SettingsRouter };
